import { render } from "./HeroiconsSolidPlay.vue?vue&type=template&id=a006353a"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPlay.vue"]])

export default __exports__